import { useQuery } from "@tanstack/react-query";
import { getTrailerEmbedCode } from "lib/client/movieinfo";
import styled from "styled-components";
import { MouseEventHandler } from "react";
import PleaseWait from "components/loader/PleaseWait";

//#region [Styles]
const STrailerContainer = styled.div`
	z-index: 2;
	position: relative;
	max-width: calc((100vw * 0.3) / 0.5625);
	margin: 0 auto;

	@media screen and (max-width: 640px) {
		max-width: 99vw;
		top: 50vh;
		transform: translateY(-50%);

	}

`;

const STrailerSizeRestrictor = styled.div`
	.video > div {
		@supports (aspect-ratio: 16 / 9) {
			aspect-ratio: 16 / 9;
			height: auto !important;
			padding-bottom: 0 !important ;
			margin: 0 auto;
			max-width: 80vw;

		}

	}

`;

const SClose = styled.button`
	border: none;
	padding: 0;
	background: none;
	color: #fff;
	margin: .25em 0 .25em auto;
	display: block;
`;

//#endregion


//#region [Props]
type TrailerPlayerProps = {
	clipId: string;
	trailerClose: MouseEventHandler
};
//#endregion

//#region [Component]
export default function TrailerPlayer({ clipId, trailerClose }: TrailerPlayerProps) {

	const { isLoading, isError, data, error } = useQuery({
		queryKey: ["trailer", clipId], // key
		queryFn: () => getTrailerEmbedCode(clipId), // loader function

		refetchOnWindowFocus: false,
		staleTime: 599999,
	} // options
	);

	return (
		<STrailerContainer onClick={trailerClose}>
			<SClose onClick={trailerClose}>Lukk trailer</SClose>
			<STrailerSizeRestrictor>
				{isLoading && <PleaseWait />}
				{!isLoading && data && <div dangerouslySetInnerHTML={{ __html: data }}></div>}
			</STrailerSizeRestrictor >
		</STrailerContainer>);

}
//#endregion